import type React from 'react'

import type { SectionLabelColor } from './styles'
import * as S from './styles'

export type { SectionLabelColor }

export interface SectionLabelProps {
  children?: React.ReactNode
  className?: string
  /** The only permitted variation. Everything else is fixed by the token. */
  color?: SectionLabelColor
  component?: React.ElementType
  id?: string
}

export const SectionLabel: React.FC<SectionLabelProps> = ({
  children,
  color = 'secondary',
  component = 'div',
  ...rest
}) => (
  <S.Root labelColor={color} component={component} {...rest}>
    {children}
  </S.Root>
)

SectionLabel.displayName = 'SectionLabel'
export default SectionLabel
